document.addEventListener('DOMContentLoaded', () => {
  initSizeGuideFinder();
});


/* =========================================================
   SIZE GUIDE FINDER
   ========================================================= */

function initSizeGuideFinder() {
  const finder = document.querySelector(
    '[data-size-guide-finder]'
  );

  if (!finder) {
    return;
  }

  const genderSelect = finder.querySelector(
    '[data-size-guide-gender]'
  );

  const categorySelect = finder.querySelector(
    '[data-size-guide-category]'
  );

  const productSelect = finder.querySelector(
    '[data-size-guide-product]'
  );

  const searchButton = finder.querySelector(
    '[data-size-guide-search]'
  );

  const results = Array.from(
    document.querySelectorAll(
      '[data-size-guide-result]'
    )
  );

  if (
    !genderSelect ||
    !categorySelect ||
    !productSelect ||
    !searchButton
  ) {
    return;
  }

  const data = buildSizeGuideData(results);

  populateGenders(
    genderSelect,
    data
  );


  /* =======================================================
     GENDER
     ======================================================= */

  genderSelect.addEventListener('change', () => {
    const gender = genderSelect.value;

    resetSelect(categorySelect);
    resetSelect(productSelect);

    productSelect.disabled = true;
    searchButton.disabled = true;

    if (!gender || !data[gender]) {
      categorySelect.disabled = true;
      return;
    }

    populateCategories(
      categorySelect,
      data[gender]
    );

    categorySelect.disabled = false;
  });


  /* =======================================================
     CATEGORY
     ======================================================= */

  categorySelect.addEventListener('change', () => {
    const gender = genderSelect.value;
    const category = categorySelect.value;

    resetSelect(productSelect);

    searchButton.disabled = true;

    if (
      !gender ||
      !category ||
      !data[gender]?.categories?.[category]
    ) {
      productSelect.disabled = true;
      return;
    }

    populateProducts(
      productSelect,
      data[gender].categories[category]
    );

    productSelect.disabled = false;
  });


  /* =======================================================
     PRODUCT
     ======================================================= */

  productSelect.addEventListener('change', () => {
    searchButton.disabled = !productSelect.value;
  });


  /* =======================================================
     SEARCH
     ======================================================= */

  searchButton.addEventListener('click', () => {
    const gender = genderSelect.value;
    const category = categorySelect.value;
    const product = productSelect.value;

    if (
      !gender ||
      !category ||
      !product
    ) {
      return;
    }

    showResult(
      results,
      gender,
      category,
      product
    );
  });
}


/* =========================================================
   BUILD DATA FROM SIZE GUIDE SECTIONS
   ========================================================= */

function buildSizeGuideData(results) {
  const data = {};

  results.forEach((result) => {
    const gender = result.dataset.gender;
    const genderLabel = result.dataset.genderLabel;

    const category = result.dataset.category;
    const categoryLabel = result.dataset.categoryLabel;

    const product = result.dataset.product;
    const productLabel = result.dataset.productLabel;

    if (
      !gender ||
      !category ||
      !product
    ) {
      return;
    }

    if (!data[gender]) {
      data[gender] = {
        label: genderLabel || gender,
        categories: {}
      };
    }

    if (!data[gender].categories[category]) {
      data[gender].categories[category] = {
        label: categoryLabel || category,
        products: {}
      };
    }

    data[gender]
      .categories[category]
      .products[product] = {
        label: productLabel || product
      };
  });

  return data;
}


/* =========================================================
   POPULATE DROPDOWNS
   ========================================================= */

function populateGenders(select, data) {
  Object.entries(data).forEach(
    ([key, item]) => {
      addOption(
        select,
        key,
        item.label
      );
    }
  );
}


function populateCategories(select, gender) {
  Object.entries(
    gender.categories
  ).forEach(
    ([key, item]) => {
      addOption(
        select,
        key,
        item.label
      );
    }
  );
}


function populateProducts(select, category) {
  Object.entries(
    category.products
  ).forEach(
    ([key, item]) => {
      addOption(
        select,
        key,
        item.label
      );
    }
  );
}


function addOption(
  select,
  value,
  label
) {
  const option =
    document.createElement('option');

  option.value = value;
  option.textContent = label;

  select.appendChild(option);
}


function resetSelect(select) {
  const placeholder =
    select.options[0]?.textContent ||
    'Select';

  select.innerHTML = '';

  const option =
    document.createElement('option');

  option.value = '';
  option.textContent = placeholder;

  select.appendChild(option);
}


/* =========================================================
   SHOW SELECTED SIZE GUIDE
   ========================================================= */

function showResult(
  results,
  gender,
  category,
  product
) {
  results.forEach((result) => {
    const isMatch =
      result.dataset.gender === gender &&
      result.dataset.category === category &&
      result.dataset.product === product;

    result.hidden = !isMatch;
  });
}


/* =========================================================
   CM / INCH SWITCHER
   Shopify Theme Editor Safe
   ========================================================= */

document.addEventListener('click', (event) => {
  const button = event.target.closest(
    '[data-unit-switcher] [data-unit]'
  );

  if (!button) {
    return;
  }

  event.preventDefault();

  const switcher = button.closest(
    '[data-unit-switcher]'
  );

  const result = button.closest(
    '[data-size-guide-result]'
  );

  if (
    !switcher ||
    !result
  ) {
    return;
  }

  const selectedUnit =
    button.dataset.unit;


  /* -------------------------
     ACTIVE BUTTON
     ------------------------- */

  const buttons =
    switcher.querySelectorAll(
      '[data-unit]'
    );

  buttons.forEach((item) => {
    item.classList.toggle(
      'is-active',
      item.dataset.unit === selectedUnit
    );
  });


  /* -------------------------
     TABLE ROWS
     ------------------------- */

  const rows =
    result.querySelectorAll(
      '[data-unit-row]'
    );

  rows.forEach((row) => {
    const rowUnit =
      row.dataset.unitRow;

    row.classList.toggle(
      'size-guide__unit-row--hidden',
      rowUnit !== selectedUnit
    );
  });
});


/* =========================================================
   SHOPIFY THEME EDITOR
   ========================================================= */

document.addEventListener(
  'shopify:section:load',
  () => {
    initSizeGuideFinder();
  }
);